import * as React from 'react';
import './LoadingOverlay.css';

export interface LoadingOverlayProps {
  text: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ text }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <div className="loading-text">{text}</div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
